import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InterstitialModalComponent } from './interstitial-modal.component';
import { FinderButtonModule } from '@finder/shared/components/finder-button/finder-button.module';

@NgModule({
    declarations: [
        InterstitialModalComponent
    ],
    imports: [
        CommonModule,
        FinderButtonModule
    ],
    exports: [
        InterstitialModalComponent
    ]
})
export class InterstitialModalModule { }
